<template>
  <div
    class="flex w-full items-center justify-center py-3 px-6 bg-white border border-argus-border rounded-lg cursor-pointer"
    :class="[disabled ? 'opacity-50' : '']"
  >
    <template v-if="label">
      <p class="text-argus-forest-600 text-sm sm:text-md">{{ label }}</p>
    </template>
    <template v-else>
      <slot></slot>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
    },
  },
}
</script>
